var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m271 362v29.99h123.763c-1.681 4.725-2.763 9.726-2.763 15.01 0 24.814 20.186 45 45 45v-30c-8.276 0-15-6.724-15-15s6.724-15 15-15h15v-30z",
    fill: "#3f303a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 452v15 15h45v-15-15z",
    fill: "#60474f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 467h45v15h-45z",
    fill: "#3f303a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181 301v91h-151c-16.5 0-30-13.5-30-30s13.5-61 30-61z",
    fill: "#e3eeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45 0c-24.853 0-45 21.147-45 46v316c0-16.5 13.5-30 30-30h30l30-34.474v-270.947l-30-26.579z",
    fill: "#6aa9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m497 46c0 8.399 6.599 15 15 15v30c-8.401 0-15 6.599-15 15 0 8.399 6.599 15 15 15v30c-8.401 0-15 6.599-15 15 0 8.399 6.599 15 15 15v30c-8.401 0-15 6.599-15 15 0 8.399 6.599 15 15 15v30c-8.401 0-15 6.599-15 15 0 8.399 6.599 15 15 15v31h-452v-332h452v31c-8.401 0-15 6.599-15 15z",
    fill: "#f0f8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m497 46c0 8.399 6.599 15 15 15v30c-8.401 0-15 6.599-15 15 0 8.399 6.599 15 15 15v30c-8.401 0-15 6.599-15 15 0 8.399 6.599 15 15 15v30c-8.401 0-15 6.599-15 15 0 8.399 6.599 15 15 15v30c-8.401 0-15 6.599-15 15 0 8.399 6.599 15 15 15v31h-226v-332h226v31c-8.401 0-15 6.599-15 15z",
    fill: "#e3eeff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m241 61h60v30h-60z",
    fill: "#e3eeff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m241 121h181v30h-181z",
    fill: "#e3eeff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m241 181h181v30h-181z",
    fill: "#e3eeff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m362 241h60v30h-60z",
    fill: "#cedaef"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m166 151c-8.276 0-15-6.724-15-15s6.724-15 15-15 15 6.724 15 15h30c0-19.53-12.578-36.024-30-42.237v-32.763h-15-15v32.763c-17.422 6.213-30 22.707-30 42.237 0 24.814 20.186 45 45 45 8.276 0 15 6.724 15 15s-6.724 15-15 15-15-6.724-15-15h-30c0 19.53 12.578 36.024 30 42.237v32.763h15 15v-32.763c17.422-6.213 30-22.707 30-42.237 0-24.814-20.186-45-45-45z",
    fill: "#ffc34d"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m181 238.237c17.422-6.213 30-22.707 30-42.237 0-24.814-20.186-45-45-45v30c8.276 0 15 6.724 15 15s-6.724 15-15 15v60h15z",
    fill: "#f93"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m181 136h30c0-19.53-12.578-36.024-30-42.237v-32.763h-15v60c8.276 0 15 6.724 15 15z",
    fill: "#f93"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#cedaef"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m286 61h15v30h-15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m286 121h136v30h-136z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m286 181h136v30h-136z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m301 422h-127.925c-46.201 0-101.752 9.346-143.075 30v15 15c41.323 20.654 96.874 30 143.075 30h127.925l30-30v-15-15z",
    fill: "#ffc34d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m173.075 512h127.925l30-30v-15h-301v15c41.323 20.654 96.874 30 143.075 30z",
    fill: "#f93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m467 422h-166v45 45h166c24.814 0 45-20.186 45-45s-20.186-45-45-45z",
    fill: "#60474f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m467 512c24.814 0 45-20.186 45-45h-211v45z",
    fill: "#3f303a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankCheck);
export default __webpack_public_path__ + "static/media/bank-check.82f65d05d4ef46677fac3a60f54f02ba.svg";
export { ForwardRef as ReactComponent };